<template>
  <div class="py-4 container-fluid">
    
    <div v-if="!isLoading" class="row">
      <div class="col-12">
        <navbaroptions
          isBlur="blur border-radius-lg py-2 start-0 end-0 mb-3 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
          toRoute="/document-card/0"
        />
      </div>
      <div class="col-12">
        <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
          <strong>Documento!</strong> Eliminado correctamente!
        </argon-alert>
      </div>
      <div
        class="col-lg-6 col-md-6 col-12 mb-4"
        v-for="document in documents"
        :key="document.id"
      >
        <!-- <router-link :to="`/Bypass`"> -->
        <documents-table :document="document" />
        <!-- </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsTable from "./components/DocumentsTable.vue";
import Navbaroptions from "@/examples/PageLayout/Navbaroptions.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "document",
  components: { DocumentsTable, Navbaroptions, ArgonAlert },
  data() {
    return {
      documents: undefined,
      isLoading: true,
      showAlert: false,
    };
  },
  created() {
    this.plain
      .get(`/documents`)
      .then((response) => {
        // console.log('DOCUMENTS TOTALES');
        // console.log(response.data);
        if (response.data.length !== 0) this.documents = response.data;
        else this.documents = [];
        this.isLoading = false;
      })
      .catch((err) => {
        this.documents = [];
        this.isLoading = false;
        console.log(err);
      });
  },
  methods: {
    deleteItemDocument(documentID) {
      this.showAlert = true
      this.documents = this.documents.filter(({ id }) => id !== documentID);
      // console.log("DOCUMENTS DOCUMENTS DOCUMENT");
      // console.log(this.documents);
      window.scrollTo(0, 0);
    },
    closeAlert(){
      this.showAlert = false;
    }
  },
};
</script>
